import "./EcommerceAccounting.css";
import logo from "../../assets/images/Elogo.jpeg";
import ContactPopup from "../ContactPopup";
import { React, useState, useEffect, useRef } from "react";
import {
    FaShoppingCart,
    FaFileInvoiceDollar,
    FaRupeeSign,
    FaBalanceScale,
    FaCheckCircle,
    FaChartBar,
    FaClipboardList,
    FaUserShield
} from "react-icons/fa";

const EcommerceAccounting = () => {

    const [openPopup, setOpenPopup] = useState(false);

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: "smooth" });
    }

    return (
        <div className="ecommerce-page">

            {/* ================= HERO ================= */}

            <section className="hero-section">

                <div className="hero-circle"></div>

                <div className="hero-content">

                    {/* <img src={logo} alt="logo" className="hero-logo" /> */}

                    <span className="company-name">
                        E-AdvisorSolution
                    </span>

                    <h1>
                        E-Commerce Monthly <br />
                        Accounting Services
                    </h1>

                    <p>
                        Complete financial management for Indian
                        e-commerce businesses
                    </p>


                    <button onClick={scrollToContact}>
                        Trusted by 200+ Sellers Across India
                    </button>
                </div>

            </section>

            {/* ================= WHY ACCOUNTING ================= */}

            <section className="section">

                <div className="section-title">

                    <img src={logo} alt="" />

                    <div>
                        <h2>
                            Why E-Commerce Businesses Need Professional Accounting
                        </h2>
                    </div>

                </div>

                <div className="card-grid">

                    <div className="info-card">

                        <FaShoppingCart className="icon" />

                        <h3>Multi-Platform Complexity</h3>

                        <p>
                            Amazon, Flipkart, Meesho, own website —
                            each platform has different settlement
                            cycles, commissions and tax rules.
                        </p>

                    </div>

                    <div className="info-card">

                        <FaFileInvoiceDollar className="icon" />

                        <h3>GST Compliance Risk</h3>

                        <p>
                            GSTR-1, GSTR-2A, GSTR-3B —
                            missing a deadline means penalties
                            of ₹100–500 per day and audit risk.
                        </p>

                    </div>

                    <div className="info-card">

                        <FaRupeeSign className="icon" />

                        <h3>TCS Reconciliation</h3>

                        <p>
                            Marketplaces deduct 1% TCS on all sales.
                            Without proper tracking, you lose
                            thousands in unclaimed credits.
                        </p>

                    </div>

                    <div className="info-card">

                        <FaBalanceScale className="icon" />

                        <h3>Working Capital Gaps</h3>

                        <p>
                            Platform hold periods of 7–45 days
                            create cash flow pressure that needs
                            careful financial management.
                        </p>

                    </div>

                </div>

            </section>

            {/* ================= SERVICE SUITE ================= */}

            <section className="service-section">

                <div className="section-title dark">

                    <img src={logo} alt="" />

                    <div>

                        <h2>Our Complete Service Suite</h2>

                        <p>
                            Everything your e-commerce business
                            needs — handled monthly
                        </p>

                    </div>

                </div>

                <div className="service-grid">

                    <div className="service-card">

                        <FaCheckCircle className="service-icon" />

                        <h3>Daily Reconciliation</h3>

                        <p>
                            Banking, payments, sales
                        </p>

                    </div>

                    <div className="service-card">

                        <FaChartBar className="service-icon" />

                        <h3>P&amp;L & Balance Sheet</h3>

                        <p>
                            Monthly financials
                        </p>

                    </div>

                    <div className="service-card">

                        <FaFileInvoiceDollar className="service-icon" />

                        <h3>GST Filing</h3>

                        <p>
                            GSTR-1, GSTR-2A, GSTR-3B
                        </p>

                    </div>

                    <div className="service-card">

                        <FaClipboardList className="service-icon" />

                        <h3>TCS Tracking</h3>

                        <p>
                            Claim credits in ITR
                        </p>

                    </div>

                    <div className="service-card">

                        <FaShoppingCart className="service-icon" />

                        <h3>Platform Reconciliation</h3>

                        <p>
                            Amazon, Flipkart & More
                        </p>

                    </div>

                    <div className="service-card">

                        <FaUserShield className="service-icon" />

                        <h3>Compliance Management</h3>

                        <p>
                            PF, ESI, TDS, Advance Tax
                        </p>

                    </div>

                </div>

            </section>

            {/* ================= DAILY & WEEKLY TASKS ================= */}

            <section className="task-section">

                <div className="section-title">

                    <img src={logo} alt="" />

                    <div>
                        <h2>What We Do — Daily & Weekly</h2>
                        <p>Professional bookkeeping activities performed every month</p>
                    </div>

                </div>

                <div className="task-grid">

                    {/* Daily */}

                    <div className="task-card">

                        <h3>⏰ Daily Tasks</h3>

                        <ul>

                            <li>Check all bank accounts & verify deposits</li>

                            <li>Reconcile payment gateway transactions</li>

                            <li>Verify sales across all platforms</li>

                            <li>Monitor refunds & cancellations</li>

                            <li>Track TCS deductions in platform accounts</li>

                            <li>Monitor inventory levels & alerts</li>

                        </ul>

                    </div>

                    {/* Weekly */}

                    <div className="task-card">

                        <h3>📅 Weekly Tasks</h3>

                        <ul>

                            <li>Process & track customer refunds</li>

                            <li>Reconcile Amazon & Flipkart accounts</li>

                            <li>Review supplier invoices against POs</li>

                            <li>Reconcile logistics & shipping costs</li>

                            <li>Verify platform fees & commissions</li>

                            <li>Manage accounts payable aging</li>

                            <li>Send payment reminders for overdue B2B</li>

                        </ul>

                    </div>

                </div>

            </section>

            {/* ================= 7 DAY PROCESS ================= */}

            <section className="process-section">

                <div className="section-title dark">

                    <img src={logo} alt="" />

                    <div>

                        <h2>Our 7-Day Month-End Close Process</h2>

                    </div>

                </div>

                <div className="process-grid">

                    <div className="process-card">

                        <span>Day 1–2</span>

                        <h3>Data Collection</h3>

                        <p>
                            Bank statements, sales data from all platforms,
                            invoices, expenses.
                        </p>

                    </div>

                    <div className="process-card">

                        <span>Day 3</span>

                        <h3>GST Reconciliation</h3>

                        <p>
                            GSTR-1, GSTR-2A matching,
                            ITC verification,
                            liability calculation.
                        </p>

                    </div>

                    <div className="process-card">

                        <span>Day 4</span>

                        <h3>Adjustments</h3>

                        <p>
                            Accruals, depreciation,
                            bad debt provisions,
                            inventory adjustments.
                        </p>

                    </div>

                    <div className="process-card">

                        <span>Day 5</span>

                        <h3>Financial Statements</h3>

                        <p>
                            Profit & Loss,
                            Balance Sheet,
                            Cash Flow Statement prepared.
                        </p>

                    </div>

                    <div className="process-card">

                        <span>Day 6</span>

                        <h3>Reports & KPIs</h3>

                        <p>
                            Channel profitability,
                            AR aging,
                            inventory metrics,
                            KPI dashboard.
                        </p>

                    </div>

                    <div className="process-card">

                        <span>Day 7</span>

                        <h3>Close & Sign-Off</h3>

                        <p>
                            Final bank reconciliation,
                            compliance check,
                            filing preparation,
                            management review.
                        </p>

                    </div>

                </div>

            </section>

            <div className="cta" ref={contactRef}>
                <div className="cta-buttons">
                    <button onClick={() => setOpenPopup(true)}>Get Started</button>
                    <ContactPopup
                        isOpen={openPopup}
                        onClose={() => setOpenPopup(false)}
                    />

                    <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
                </div>
            </div>

        </div>
    );
};

export default EcommerceAccounting;